/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Korean
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': '제목이 없는 페이지',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': '새 페이지를 만들고 링크로 삽입',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Confluence 페이지 만들기',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Confluence에서 열기',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': '페이지를 만들었습니다',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': '페이지를 만듦',
  'editorExtensionLinkCreate.confluencePage.title': '새 페이지 만들기',
  'editorExtensionLinkCreate.genericError.description': '페이지를 새로 고친 후 다시 시도하세요.',
  'editorExtensionLinkCreate.genericError.title': '문제가 발생했습니다',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': '인라인 이슈를 만들고 이슈를 링크로 삽입',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description-issue-terminology-refresh-m4':
    '업무 항목을 인라인으로 만들고 업무 항목을 링크로 삽입',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Jira 이슈 만들기',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title-issue-terminology-refresh-m4': 'Jira 업무 항목 만들기',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Jira에서 열기',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': '이슈를 만들었습니다',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description-issue-terminology-refresh-m4':
    '업무 항목를 만들었습니다',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': '이슈를 만듦',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title-issue-terminology-refresh-m4': '업무 항목를 만듦',
  'editorExtensionLinkCreate.jiraIssue.title': '새 이슈 만들기',
  'editorExtensionLinkCreate.jiraIssue.title-issue-terminology-refresh-m4': '새 업무 항목 만들기',
  'editorExtensionLinkCreate.keyword.create': '만들기',
  'editorExtensionLinkCreate.keyword.issue': '이슈',
  'editorExtensionLinkCreate.keyword.new': '새 항목',
  'editorExtensionLinkCreate.keyword.page': '페이지',
  'editorExtensionLinkCreate.keyword.publish': '게시',
  'editorExtensionLinkCreate.keyword.raise': '제기',
  'editorExtensionLinkCreate.keyword.space': '스페이스',
  'editorExtensionLinkCreate.keyword.ticket': '티켓',
};
